import { useEnrollmentStore } from '@/stores'
import { readWidgetLeadData } from '../../../state/widgetLeadStorage'
import { getEnrollmentDraftAddress } from '../../../utils/enrollmentDraftSelectors'
import type { AddressParts, ApplicationFormData } from '../types'
import { hasFormattedAddressDetails } from '.'

export const persistAddressFields = (address: AddressParts) => {
  useEnrollmentStore.getState().updateFormData({
    addressLine1: address.addressLine1 ?? '',
    city: address.city ?? '',
    state: address.state ?? '',
    zipCode: address.zipCode ?? ''
  })
}

export const buildAddressDisplayValue = (formData: ApplicationFormData) => {
  const directFullAddress = getEnrollmentDraftAddress() || readWidgetLeadData().address || ''

  if (directFullAddress) return directFullAddress

  if (
    hasFormattedAddressDetails(
      formData.addressLine1,
      formData.city,
      formData.state,
      formData.zipCode
    )
  ) {
    return formData.addressLine1
  }

  if (formData.addressLine1 && formData.city && formData.state && formData.zipCode) {
    return `${formData.addressLine1}, ${formData.city}, ${formData.state} ${formData.zipCode}`
  }

  if (formData.addressLine1 && formData.city && formData.state) {
    return `${formData.addressLine1}, ${formData.city}, ${formData.state}`
  }

  return formData.addressLine1
}
